// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'mcp';

export const Component = () => (
  <g fill='currentColor'>
    <path d='M11.445 2.19a3.99 3.99 0 0 1 6.771 3.386 3.985 3.985 0 0 1 3.313 1.057l.074.072.047.047.071.074a3.99 3.99 0 0 1-.071 5.57l-8.166 8.167a.266.266 0 0 0 0 .376l1.677 1.677a.799.799 0 0 1-1.13 1.128l-1.676-1.677a1.862 1.862 0 0 1 0-2.633l8.166-8.167a2.394 2.394 0 0 0 0-3.386l-.047-.047-.044-.043a2.394 2.394 0 0 0-3.342.043l-6.82 6.819a.798.798 0 0 1-1.128-1.128l6.82-6.82a2.395 2.395 0 0 0-3.386-3.386l-9.03 9.03a.799.799 0 0 1-1.129-1.129z' />
    <path d='M13.701 4.449a.798.798 0 0 1 1.13 1.127l-6.678 6.68-.164.18a2.395 2.395 0 0 0 .164 3.205l.181.164c.94.767 2.328.712 3.204-.164l6.678-6.678a.798.798 0 0 1 1.13 1.128l-6.679 6.679a3.99 3.99 0 0 1-5.569.072l-.074-.072a3.991 3.991 0 0 1 0-5.644z' />
  </g>
);

export const viewBox = '0 0 25 25';
